import { Audio } from './compnents/audio.component';

export * from './index.model';

export default Audio;
